import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";

export enum ConfirmRequestDialogAction {
  Confirm = 'CONFIRM',
  Cancel = 'CANCEL'
}

export interface ConfirmRequestDialogComponentData {
  title?: string,
   confirmMessageSecond?: string,
  confirmMessage?: string,
  isArlert?: boolean
}

@Component({
  standalone: true,
  providers: [
    CommonModule,
    MatDialogModule
  ],
  selector: 'app-confirm-request-dialog',
  templateUrl: './confirm-request-dialog.component.html',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatListModule
  ],
  styleUrls: ['./confirm-request-dialog.component.scss']
})
export class ConfirmRequestDialogComponent implements OnInit {
  ConfirmRequestDialogAction = ConfirmRequestDialogAction

  get title (): string {
    return this.data.title ?? 'Confirmation'
  }

  get confirmMessage (): string {
    return this.data.confirmMessage ?? 'Are you sure you want to perform this action?'
  };

  get confirmMessageSecond (): string {
    return this.data.confirmMessageSecond ?? 'This action is irreversible and the data will be permanently deleted.'
  };

  get isArlert () : boolean {
    return this.data.isArlert ?? false
  }

  constructor (
    @Inject(MAT_DIALOG_DATA) protected readonly data: ConfirmRequestDialogComponentData
  ) {
  }

  ngOnInit (): void {
  }
}
